import { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../home/components/Footer';

export default function ServicesPage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="relative min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
        <div className="px-4 sm:px-8 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2 sm:gap-3">
              <img
                src="https://static.readdy.ai/image/d9bb5601c98f22586a2b11870925187d/b857441a8282eff6e67d45b8b6cd5de0.jpeg"
                alt="Horizon Pathways Logo"
                className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
              />
              <span className="text-base sm:text-xl font-semibold text-gray-900">
                Horizon Pathways
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-8">
              <Link
                to="/"
                className="text-sm font-medium text-gray-700 transition-colors hover:text-emerald-600 whitespace-nowrap"
              >
                Home
              </Link>
              <Link
                to="/products"
                className="text-sm font-medium text-gray-700 transition-colors hover:text-emerald-600 whitespace-nowrap"
              >
                Products
              </Link>
              <Link
                to="/services"
                className="text-sm font-medium text-emerald-600 border-b-2 border-emerald-600 whitespace-nowrap"
              >
                Services
              </Link>
              <Link
                to="/about"
                className="text-sm font-medium text-gray-700 transition-colors hover:text-emerald-600 whitespace-nowrap"
              >
                About
              </Link>
              <Link
                to="/contact"
                className="text-sm font-medium text-gray-700 transition-colors hover:text-emerald-600 whitespace-nowrap"
              >
                Contact
              </Link>
            </div>

            {/* Right Side */}
            <div className="flex items-center gap-3 sm:gap-4">
              <Link
                to="/contact"
                className="hidden sm:block px-4 sm:px-6 py-2 border-2 border-emerald-600 text-emerald-600 rounded-full text-sm font-medium transition-all hover:bg-emerald-600 hover:text-white whitespace-nowrap"
              >
                Get Quote
              </Link>

              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer"
                aria-label="Toggle menu"
              >
                <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>
      )}

      {/* Mobile Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-64 bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out md:hidden ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Mobile Menu Header */}
          <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200">
            <span className="text-lg font-semibold text-gray-900">Menu</span>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-8 h-8 flex items-center justify-center text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer"
              aria-label="Close menu"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
          </div>

          {/* Mobile Menu Links */}
          <div className="flex-1 overflow-y-auto py-6">
            <div className="flex flex-col space-y-1 px-4">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-3 text-base font-medium text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors cursor-pointer"
              >
                Home
              </Link>
              <Link
                to="/products"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-3 text-base font-medium text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors cursor-pointer"
              >
                Products
              </Link>
              <Link
                to="/services"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-3 text-base font-medium text-emerald-600 bg-emerald-50 rounded-lg cursor-pointer"
              >
                Services
              </Link>
              <Link
                to="/about"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-3 text-base font-medium text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors cursor-pointer"
              >
                About
              </Link>
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-3 text-base font-medium text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors cursor-pointer"
              >
                Contact
              </Link>
            </div>

            {/* Mobile Menu CTA */}
            <div className="px-4 mt-6">
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block w-full px-6 py-3 bg-emerald-600 text-white text-center rounded-full text-base font-medium hover:bg-emerald-700 transition-all whitespace-nowrap cursor-pointer"
              >
                Get Quote
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="pt-20">
        {/* Hero Section */}
        <section className="relative pt-24 sm:pt-28 md:pt-32 pb-12 sm:pb-16 md:pb-20 px-4 sm:px-6 md:px-8 bg-gradient-to-br from-emerald-50 to-amber-50">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-3xl">
              <p className="text-xs sm:text-sm font-semibold text-emerald-700 tracking-widest uppercase mb-3 sm:mb-4">
                OUR SERVICES
              </p>
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight mb-4 sm:mb-6">
                Comprehensive
                <br />
                <span className="italic font-serif text-emerald-700">Export Solutions</span>
              </h1>
              <p className="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed">
                From documentation to delivery, we provide end-to-end export services ensuring seamless international trade. Our expert team handles every aspect of your export journey with precision and reliability.
              </p>
            </div>
          </div>
        </section>

        {/* Export Documentation Section */}
        <section id="export-documentation" className="py-12 sm:py-16 md:py-20 lg:py-24 px-4 sm:px-6 md:px-8 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 lg:gap-16 items-center">
              <div>
                <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-teal-50 rounded-full mb-4 sm:mb-6">
                  <i className="ri-file-list-3-line text-lg sm:text-xl text-teal-700"></i>
                  <span className="text-xs sm:text-sm font-semibold text-teal-700">SERVICE 01</span>
                </div>
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
                  Export Documentation
                </h2>
                <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8">
                  Navigate complex export paperwork with ease. Our documentation experts ensure all your certificates, invoices, and compliance documents are accurate and complete, preventing customs delays and ensuring smooth international transactions.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                  {[
                    { icon: 'ri-file-text-line', title: 'Commercial Invoice', desc: 'Detailed transaction documents' },
                    { icon: 'ri-ship-line', title: 'Bill of Lading', desc: 'Shipping and cargo receipts' },
                    { icon: 'ri-award-line', title: 'Certificates of Origin', desc: 'Product origin verification' },
                    { icon: 'ri-shield-check-line', title: 'Phytosanitary Certs', desc: 'Plant health compliance' },
                    { icon: 'ri-medicine-bottle-line', title: 'Health Certificates', desc: 'Food safety documentation' },
                    { icon: 'ri-bank-line', title: 'Letter of Credit', desc: 'Payment security documents' },
                    { icon: 'ri-truck-line', title: 'Packing Lists', desc: 'Detailed cargo contents' },
                    { icon: 'ri-checkbox-circle-line', title: 'Inspection Reports', desc: 'Quality verification records' }
                  ].map((doc, idx) => (
                    <div key={idx} className="flex gap-3 sm:gap-4">
                      <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-50 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0">
                        <i className={`${doc.icon} text-lg sm:text-xl text-teal-700`}></i>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">{doc.title}</h4>
                        <p className="text-xs sm:text-sm text-gray-600">{doc.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="relative order-first lg:order-last">
                <img
                  src="https://public.readdy.ai/ai/img_res/a7a6978b9c1a8403edd172e188918898.jpg"
                  alt="Export Documentation"
                  className="w-full h-64 sm:h-80 md:h-96 lg:h-[700px] object-cover object-top rounded-2xl sm:rounded-3xl shadow-xl sm:shadow-2xl"
                />
                <div className="absolute -bottom-6 -left-4 sm:-bottom-8 sm:-left-8 bg-teal-600 text-white p-4 sm:p-6 md:p-8 rounded-xl sm:rounded-2xl shadow-lg sm:shadow-xl">
                  <div className="text-2xl sm:text-3xl md:text-4xl font-bold mb-1 sm:mb-2">100%</div>
                  <div className="text-xs sm:text-sm">Compliance Rate</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Quality Assurance Section */}
        <section id="quality-assurance" className="py-12 sm:py-16 md:py-20 lg:py-24 px-4 sm:px-6 md:px-8" style={{ backgroundColor: '#F8F6F3' }}>
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 lg:gap-16 items-center">
              <div className="order-2 lg:order-1 relative">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20food%20quality%20control%20laboratory%20with%20scientist%20in%20white%20coat%20conducting%20detailed%20analysis%20of%20agricultural%20products%20using%20advanced%20testing%20equipment%20microscopes%20and%20quality%20inspection%20tools%20with%20samples%20of%20grains%20pulses%20and%20spices%20on%20clean%20work%20surfaces%20emphasizing%20scientific%20precision%20hygiene%20and%20international%20food%20safety%20standards&width=600&height=700&seq=quality-assurance-img-001&orientation=portrait"
                  alt="Quality Assurance"
                  className="w-full h-64 sm:h-80 md:h-96 lg:h-[700px] object-cover object-top rounded-2xl sm:rounded-3xl shadow-xl sm:shadow-2xl"
                />
                <div className="absolute -top-6 -right-4 sm:-top-8 sm:-right-8 bg-orange-500 text-white p-4 sm:p-6 md:p-8 rounded-xl sm:rounded-2xl shadow-lg sm:shadow-xl">
                  <div className="text-2xl sm:text-3xl md:text-4xl font-bold mb-1 sm:mb-2">6+</div>
                  <div className="text-xs sm:text-sm">Certifications</div>
                </div>
              </div>

              <div className="order-1 lg:order-2">
                <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-orange-50 rounded-full mb-4 sm:mb-6">
                  <i className="ri-shield-check-line text-lg sm:text-xl text-orange-700"></i>
                  <span className="text-xs sm:text-sm font-semibold text-orange-700">SERVICE 02</span>
                </div>
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
                  Quality Assurance
                </h2>
                <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8">
                  Every product undergoes rigorous multi-stage quality inspections. Our state-of-the-art laboratories and experienced quality control team ensure your agricultural products meet the highest international standards, protecting your reputation in global markets.
                </p>

                <div className="space-y-4 sm:space-y-6 mb-6 sm:mb-8">
                  {[
                    { stage: 'Pre-Purchase Inspection', desc: 'Supplier verification and sample testing before procurement' },
                    { stage: 'Laboratory Testing', desc: 'Chemical, microbiological, and nutritional analysis' },
                    { stage: 'Processing Monitoring', desc: 'Quality checks during cleaning, grading, and packaging' },
                    { stage: 'Pre-Shipment Inspection', desc: 'Final verification before international dispatch' }
                  ].map((stage, idx) => (
                    <div key={idx} className="flex gap-3 sm:gap-4 items-start">
                      <div className="w-8 h-8 sm:w-10 sm:h-10 bg-orange-500 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold text-sm sm:text-base">
                        {idx + 1}
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">{stage.stage}</h4>
                        <p className="text-xs sm:text-sm text-gray-600">{stage.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="flex flex-wrap gap-2 sm:gap-3">
                  {['FSSAI', 'ISO 22000', 'HACCP', 'Organic', 'GMP', 'USFDA'].map((cert) => (
                    <span key={cert} className="px-3 sm:px-4 py-1.5 sm:py-2 bg-white border-2 border-orange-200 rounded-full text-xs sm:text-sm font-semibold text-gray-900">
                      {cert}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Logistics Support Section */}
        <section id="logistics-support" className="py-12 sm:py-16 md:py-20 lg:py-24 px-4 sm:px-6 md:px-8 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 lg:gap-16 items-center">
              <div>
                <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full mb-4 sm:mb-6" style={{ backgroundColor: '#E6DFF3' }}>
                  <i className="ri-global-line text-lg sm:text-xl" style={{ color: '#8B7AB8' }}></i>
                  <span className="text-xs sm:text-sm font-semibold" style={{ color: '#8B7AB8' }}>SERVICE 03</span>
                </div>
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
                  Logistics Support
                </h2>
                <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8">
                  Reliable global shipping solutions tailored to your needs. We partner with leading freight forwarders and shipping lines to ensure your products reach their destination safely, on time, and cost-effectively, with full tracking and insurance coverage.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-8">
                  {[
                    { icon: 'ri-ship-2-line', title: 'Sea Freight', desc: 'Cost-effective bulk shipping' },
                    { icon: 'ri-plane-line', title: 'Air Freight', desc: 'Fast international delivery' },
                    { icon: 'ri-truck-line', title: 'Land Transport', desc: 'Regional overland shipping' },
                    { icon: 'ri-home-4-line', title: 'Door-to-Door', desc: 'Complete logistics management' },
                    { icon: 'ri-building-2-line', title: 'Warehousing', desc: 'Secure storage facilities' },
                    { icon: 'ri-route-line', title: 'Route Optimization', desc: 'Efficient delivery planning' }
                  ].map((service, idx) => (
                    <div key={idx} className="flex gap-3 sm:gap-4">
                      <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#E6DFF3' }}>
                        <i className={`${service.icon} text-lg sm:text-xl`} style={{ color: '#8B7AB8' }}></i>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">{service.title}</h4>
                        <p className="text-xs sm:text-sm text-gray-600">{service.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="bg-gradient-to-r from-purple-50 to-indigo-50 p-4 sm:p-6 rounded-xl sm:rounded-2xl">
                  <h4 className="font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2 text-sm sm:text-base">
                    <i className="ri-flashlight-line text-lg sm:text-xl text-purple-600"></i>
                    Advanced Features
                  </h4>
                  <ul className="space-y-2 text-xs sm:text-sm text-gray-700">
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-green-600 flex-shrink-0"></i>
                      <span>Real-time shipment tracking and updates</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-green-600 flex-shrink-0"></i>
                      <span>Temperature-controlled containers for sensitive products</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-green-600 flex-shrink-0"></i>
                      <span>Comprehensive cargo insurance coverage</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-green-600 flex-shrink-0"></i>
                      <span>Expert handling of perishable agricultural goods</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="relative order-first lg:order-last">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20international%20shipping%20port%20with%20organized%20cargo%20containers%20freight%20ships%20and%20logistics%20operations%20showing%20efficient%20global%20trade%20transportation%20with%20cranes%20loading%20agricultural%20export%20goods%20in%20bright%20daylight%20emphasizing%20professional%20supply%20chain%20management%20reliable%20shipping%20services%20and%20worldwide%20distribution%20network&width=600&height=700&seq=logistics-support-img-001&orientation=portrait"
                  alt="Logistics Support"
                  className="w-full h-64 sm:h-80 md:h-96 lg:h-[700px] object-cover object-top rounded-2xl sm:rounded-3xl shadow-xl sm:shadow-2xl"
                />
                <div className="absolute -bottom-6 -left-4 sm:-bottom-8 sm:-left-8 text-white p-4 sm:p-6 md:p-8 rounded-xl sm:rounded-2xl shadow-lg sm:shadow-xl" style={{ backgroundColor: '#8B7AB8' }}>
                  <div className="text-2xl sm:text-3xl md:text-4xl font-bold mb-1 sm:mb-2">50+</div>
                  <div className="text-xs sm:text-sm">Countries Served</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Customs Clearance Section */}
        <section id="customs-clearance" className="py-12 sm:py-16 md:py-20 lg:py-24 px-4 sm:px-6 md:px-8" style={{ backgroundColor: '#F0FDF4' }}>
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 lg:gap-16 items-center">
              <div className="order-2 lg:order-1 relative">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20customs%20office%20with%20officers%20reviewing%20international%20trade%20documents%20and%20cargo%20inspection%20processes%20showing%20organized%20paperwork%20stamps%20and%20official%20customs%20clearance%20procedures%20in%20a%20bright%20modern%20government%20facility%20emphasizing%20regulatory%20compliance%20efficient%20processing%20and%20smooth%20import-export%20operations&width=600&height=700&seq=customs-clearance-img-001&orientation=portrait"
                  alt="Customs Clearance"
                  className="w-full h-64 sm:h-80 md:h-96 lg:h-[700px] object-cover object-top rounded-2xl sm:rounded-3xl shadow-xl sm:shadow-2xl"
                />
                <div className="absolute -top-6 -right-4 sm:-top-8 sm:-right-8 bg-emerald-700 text-white p-4 sm:p-6 md:p-8 rounded-xl sm:rounded-2xl shadow-lg sm:shadow-xl">
                  <div className="text-2xl sm:text-3xl md:text-4xl font-bold mb-1 sm:mb-2">98%</div>
                  <div className="text-xs sm:text-sm">Success Rate</div>
                </div>
              </div>

              <div className="order-1 lg:order-2">
                <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-emerald-50 rounded-full mb-4 sm:mb-6">
                  <i className="ri-government-line text-lg sm:text-xl text-emerald-700"></i>
                  <span className="text-xs sm:text-sm font-semibold text-emerald-700">SERVICE 04</span>
                </div>
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
                  Customs Clearance
                </h2>
                <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8">
                  Navigate customs procedures effortlessly with our expert brokerage team. We maintain strong relationships with customs authorities worldwide, ensuring fast clearance, accurate duty calculations, and full regulatory compliance for all your shipments.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-8">
                  {[
                    { icon: 'ri-file-list-line', title: 'Documentation Support', desc: 'Complete customs paperwork' },
                    { icon: 'ri-calculator-line', title: 'Duty Calculation', desc: 'Accurate tariff assessment' },
                    { icon: 'ri-user-star-line', title: 'Customs Liaison', desc: 'Direct authority communication' },
                    { icon: 'ri-shield-check-line', title: 'Compliance Check', desc: 'Regulatory verification' },
                    { icon: 'ri-barcode-line', title: 'HS Code Classification', desc: 'Proper product coding' },
                    { icon: 'ri-time-line', title: 'Fast-Track Processing', desc: 'Expedited clearance' }
                  ].map((service, idx) => (
                    <div key={idx} className="flex gap-3 sm:gap-4">
                      <div className="w-10 h-10 sm:w-12 sm:h-12 bg-emerald-50 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0">
                        <i className={`${service.icon} text-lg sm:text-xl text-emerald-700`}></i>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">{service.title}</h4>
                        <p className="text-xs sm:text-sm text-gray-600">{service.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl border-2 border-emerald-100">
                  <h4 className="font-semibold text-gray-900 mb-3 sm:mb-4 text-sm sm:text-base">Why Choose Our Customs Services?</h4>
                  <div className="space-y-2 sm:space-y-3">
                    <div className="flex items-start gap-2 sm:gap-3">
                      <i className="ri-shield-star-line text-lg sm:text-xl text-emerald-600 mt-0.5 sm:mt-1 flex-shrink-0"></i>
                      <p className="text-xs sm:text-sm text-gray-700">Licensed customs brokers with 15+ years of experience</p>
                    </div>
                    <div className="flex items-start gap-2 sm:gap-3">
                      <i className="ri-global-line text-lg sm:text-xl text-emerald-600 mt-0.5 sm:mt-1 flex-shrink-0"></i>
                      <p className="text-xs sm:text-sm text-gray-700">Expertise in 50+ countries' customs regulations</p>
                    </div>
                    <div className="flex items-start gap-2 sm:gap-3">
                      <i className="ri-timer-flash-line text-lg sm:text-xl text-emerald-600 mt-0.5 sm:mt-1 flex-shrink-0"></i>
                      <p className="text-xs sm:text-sm text-gray-700">Average clearance time: 24-48 hours</p>
                    </div>
                    <div className="flex items-start gap-2 sm:gap-3">
                      <i className="ri-hand-coin-line text-lg sm:text-xl text-emerald-600 mt-0.5 sm:mt-1 flex-shrink-0"></i>
                      <p className="text-xs sm:text-sm text-gray-700">Minimize duties through proper classification and trade agreements</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 bg-gradient-to-br from-emerald-700 to-emerald-900">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
              Ready to Export with Confidence?
            </h2>
            <p className="text-emerald-100 text-sm sm:text-base md:text-lg mb-8 sm:mb-10 leading-relaxed px-4">
              Let our expert team handle every aspect of your export journey. From documentation to delivery, we ensure seamless international trade operations.
            </p>
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 justify-center">
              <Link
                to="/#contact"
                className="px-6 sm:px-8 md:px-10 py-3 sm:py-3.5 md:py-4 bg-white text-emerald-700 rounded-full text-sm sm:text-base font-semibold hover:bg-emerald-50 transition-all whitespace-nowrap cursor-pointer"
              >
                Get Started Today
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <button className="px-6 sm:px-8 md:px-10 py-3 sm:py-3.5 md:py-4 border-2 border-white text-white rounded-full text-sm sm:text-base font-semibold hover:bg-white hover:text-emerald-700 transition-all whitespace-nowrap">
                Download Brochure
                <i className="ri-download-line ml-2"></i>
              </button>
            </div>
          </div>
        </section>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}
